import { render, staticRenderFns } from "./DiamondData.vue?vue&type=template&id=0b318074"
import script from "./DiamondData.vue?vue&type=script&lang=js"
export * from "./DiamondData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports